import React from 'react'

const Offline = () => {
  return (
    <div className='w-10/12 text-center mx-auto h-96 align-middle m-4 p-4 text-4xl'>
        <h1 className='m-3 p-3 font-extrabold '>Looks like you're offline!</h1>
        <h1 className='m-3 p-3 font-extrabold '>Check Your internet connection</h1>
    </div>
  )
}

export default Offline
